/* eslint-disable no-template-curly-in-string */
const config = {
  app: {
    urlServer: 'https://emitir-api.emissaoonline.com.br/api',
    urlServerPanel: 'https://apiemissaoweb.vaultid.com.br/',
    partnerNames:
      '["arsoluti", "ardigisec", "arobjectti", "arrp", "arpartner"]',
    skuBirdIdTrial: '2970',
    negociations: '["34333","34334", "34544"]',
    poolServer: '${VUE_APP_POOL_URL_SERVER}',
    vlineUrl: 'https://vline.soluti.com.br/',
    reCaptchaSiKey: '6LdgPN0qAAAAAK88wIV9jUeXwOkh3b07WY3-29Jt',
  },
  version: {
    commit: '9d45fc295d8991702a66eaca6b93d8587957900b',
    branch: '',
    tag: '2.27.1',
    repo: 'online-emission-frontend',
    build: '980',
    date: '2025-08-14T22:01:26.1755208886Z',
  },
}

type Config = typeof config

export default config as Config
